import {
  cookiePolicy,
  setWindowCookieActions,
  DOMContentLoadedCookieHandler,
  setCookiePolicy,
} from './cookie-policy-setup';

setWindowCookieActions();
document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);

export const newCookiePolicy = cookiePolicy();

export function handleDOMContentLoaded() {
  if (
    window.location.pathname !== '/start' &&
    window.location.pathname !== '/cookie-policy' &&
    window.location.pathname !== '/cookie-policy/disagree'
  ) {
    store.set('cookiesVisited', 'true');
  }

  DOMContentLoadedCookieHandler();

  const inputs = document.querySelectorAll('input.cookies-disagree');
  for (let i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('change', handleRadioChange);
  }

  for (const [name, value] of Object.entries(cookiePolicy())) {
    const radioButton = document
      .getElementsByTagName('body')[0]
      ?.querySelector('input[name="' + name + '"][value="' + (value | 0) + '"]');
    radioButton && radioButton.click();
  }

  const confirmChoicesBtn = document.getElementById('back-button');
  confirmChoicesBtn && confirmChoicesBtn.addEventListener('click', handleConfirmChoicesClick);
}

export function handleRadioChange(event) {
  const key = event.target.name;
  const value = event.target.value === '1';
  newCookiePolicy[key] = value;
}

export function handleConfirmChoicesClick() {
  store.set('cookiesVisited', 'true');
  Object.keys(newCookiePolicy).length !== 0 && setCookiePolicy(newCookiePolicy);
  document.referrer.length > 1 && (window.location = document.referrer);
}
